import parse from 'html-react-parser';

import { tierOneHeadings } from './constants';
import { slugify } from '@/utils/slugify';
interface Heading {
  hashAnchor: string;
  title: string;
  type: string;
}

// type Image = string;

/**
 * @description Extracts headings from HTML
 */
export function getHeadings(html: string): Heading[] {
  if (!html) {
    return [];
  }

  const headings: Heading[] = [];
  // const images: Image[] = [];

  const replace = node => {
    if (tierOneHeadings.indexOf(node.name) >= 0) {
      const text = node.children?.map(child => {
        const textContent =
          child.type === 'text'
            ? child
            : typeof child?.children === typeof [] &&
              child?.children?.find(el => el.type === 'text' && el.data !== ' ');

        return textContent?.data ? textContent.data : textContent?.children?.[0]?.data;
      });

      if (text) {
        headings.push({
          hashAnchor: slugify(text.join('')),
          title: text.join(''),
          type: node.name,
        });
      }
    }

    // if (node?.attribs && node.name === 'img' && node.attribs.src) {
    //   images.push(node.attribs.src);
    // }
  };

  parse(html, { replace });

  return headings;
}
